import * as Sentry from '@sentry/nextjs';
import Layout from 'components/layout';
import Springboard from 'components/springboard';
import { getAllKeywords } from 'lib/api/keywords';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { toPlainText } from 'utilities/blockText';
import { allCommandsByName } from 'utilities/commands';
import { KeywordType } from 'utilities/propTypes';

const REVALIDATE_TIME_MINUTES = 15;
const REVALIDATE_TIME_SECONDS = REVALIDATE_TIME_MINUTES * 60;

export const getStaticProps = Sentry.wrapGetStaticPropsWithSentry(
  async ({ preview = false }) => {
    const keywords = await getAllKeywords({ preview });
    return {
      props: {
        keywords,
        preview,
      },
      revalidate: REVALIDATE_TIME_SECONDS,
    };
  }
);

const Go = ({ keywords }) => {
  const router = useRouter();
  const keyword = router.query.keyword || 'resist'; // Use keyword from query params, otherwise default message.

  // Rebuild the path with only the `keyword` query param so we preservve that
  // but remove excess tracking stuff we don't want
  const canonicalPath = `${router.asPath.split('?')[0]}/?keyword=${keyword}`;

  // If the command does not exist in CMS, try to get it from command map or use default message.
  const keywordMatch = keywords.find((k) => k.keyword === keyword);
  const entry = allCommandsByName.get(keyword);
  const entryDescription = entry
    ? entry.command.description
    : 'Introduce yourself!';

  const message = keywordMatch?.description
    ? toPlainText(keywordMatch.description)
    : entryDescription;

  return (
    <Layout
      title={`Go: ${keyword}`}
      description={message}
      canonicalPath={canonicalPath}
    >
      <Springboard keyword={keyword} message={message} />
    </Layout>
  );
};

Go.propTypes = {
  keywords: PropTypes.arrayOf(KeywordType),
  preview: PropTypes.bool,
};

export default Go;
